import { Controller } from '@hotwired/stimulus';
const axios = require('axios');

export default class extends Controller {
    static targets = [
        'currentPage', 
        'loadMore', 
        'loadMoreContainer', 
        'loadMoreMobile', 
        'checkbox', 
        'form',
        'resetFilters',
        'selectedFilters',
        'ageFilter',
        'searchInput',
        'mobileMenu',
        'mobileCount',
        'container',
        'postContainer',
        'noResultsContainer',
        'tripCountContainer',
    ];

	connect() {
        // Get all checkboxes and on change filter results
        const buttons = this.checkboxTargets;
        [].map.call(buttons, (button) => {
            button.addEventListener("change", () => { this.submit() });
        });

        const ageFilter = this.ageFilterTarget;
        ageFilter.addEventListener("change", () => { this.submit() });

        // Load more posts
        this.loadMoreTarget.addEventListener("click", () => { this.loadMorePosts() });
        this.loadMoreMobileTarget.addEventListener("click", () => { this.loadMorePosts() });

        // Submit form
        this.formTarget.addEventListener("submit", (e) => { 
            e.preventDefault();
            this.resetPaged();
        
            this.submit();
        
            return false;
        });

        // Reset filters on button click
        this.resetFiltersTarget.addEventListener("click",() => { this.resetFilters() });

        this.resetPaged();
        this.emptySelectedFilters();
        this.resetFieldsOnReload();
	}

    resetFilters() {
        this.resetPaged();
    
        const buttons = this.checkboxTargets;
        const agesFilters = this.ageFilterTarget;
        const searchFilter = this.searchInputTarget;
    
        searchFilter.value = "";
    
        [].map.call(buttons, (button) => {
          if (button.checked) {
            button.checked = false;
          }
        });
    
        agesFilters.value = "";
    
        this.submit();
    }

    searchSubmit(e) {
        // Fix that form does not submit but also gets ajax request.
    }

    showSelectedFilters() {
        // First empty the filter container
        this.emptySelectedFilters();

        // Checks for selected filter, returns the name and the type in an array
        const filterArray = this.checkForSelectedFilter();

        // Return if no more filters selected
        if (filterArray.length === 0) {
          return;
        }

        // Create header for selected filters
        let filterHeader = `<div class="flex justify-between mb-3 text-base"><span class="font-bold">Gekozen filters</span> <a class="text-green-500 underline cursor-pointer" data-action="click->trip-archive#resetFilters">Wis alle</a></div>`;
    
        const selectedFiltersContainer = this.selectedFiltersTarget;
    
        // Add header under search bar
        selectedFiltersContainer.insertAdjacentHTML("beforeend", filterHeader);
    
        // For each selected filter it will create a p tag with the filter name and type
        filterArray.forEach((filterItem) => {
          selectedFiltersContainer.insertAdjacentHTML(
            "beforeend",
            `<p class="flex justify-between mb-2 text-base">${filterItem[0]}: ${filterItem[1]}<a class="cursor-pointer text-grey-300 font-bold" id="erase-selected-filter" data-filter-item="${filterItem[1]}">x</a></p>`
          );
        });
    
        // Create eventlistener to delete specific Selected Filter
        document
          .querySelectorAll("#erase-selected-filter")
          .forEach((filterItem) => {
            filterItem.addEventListener("click", () => { this.removeSelectedFilter(filterItem) });
        });
    }

    removeSelectedFilter(filterItem) {
        // Selects filtername from dataset on selected filtername
        let filterName = filterItem.dataset.filterItem.toLowerCase();

        // Upon click searches for the name on the input boxes and unchecks the one with the selected filter name
        this.checkboxTargets.forEach((filterItem) => {
          if (filterItem.value === filterName) {
            filterItem.checked = false;
          }
        });

        // Re-submit the form
        this.submit();
    }

    checkForSelectedFilter() {
        let Arr = [];
        // Creates an array with nested arrays for selected filteritems with their name and type
        this.checkboxTargets.forEach((filterItem) => {
          if (filterItem.type == "checkbox" && filterItem.checked)
            Arr.push([
              filterItem
                .closest(".trip-archive-col")
                .querySelector(".category label").innerHTML,
              filterItem.value.charAt(0).toUpperCase() + filterItem.value.slice(1),
            ]);
        });

        return Arr;
    }

    emptySelectedFilters() {
        // Sets the container to an empty string
        this.selectedFiltersTarget.innerHTML = "";
    }

    resetFieldsOnReload() {
        const buttons = this.checkboxTargets;
        const agesFilters = this.ageFilterTargets;
        const searchFilter = this.searchInputTarget;
    
        searchFilter.value = "";
    
        [].map.call(buttons, (button) => {
          if (button.checked) {
            button.checked = false;
          }
        });
    
        [].map.call(agesFilters, (filter) => {
          filter.value = "";
        });
    }

    submit(e) {
        this.resetPaged();
        this.closeMobileMenu();

        // Show the selected filters under the search field
        this.showSelectedFilters();

        // Get form data
        const formData = new FormData(this.formTarget);
        var archiveContainer = this.containerTarget;
        archiveContainer.setAttribute("data-group-loading", "true");
    
        // Get container
        var postContainer = this.postContainerTarget;
        var noResultContainer = this.noResultsContainerTarget;
        var counter = this.tripCountContainerTarget;
        var loadMoreContainerButton = this.loadMoreContainerTarget;
        var loadMoreMobile = this.loadMoreMobileTarget;
        var mobileCountText = this.mobileCountTarget;
    
        // Ajax request
        axios
          .post(supersage.ajaxURL, formData)
          .then((response) => {
            if (response.status == "200") {
              if (postContainer && response.data != "") {
                // Show no result text
                if (response.data.type == "no-result") {
                  if (noResultContainer.classList.contains("hidden")) {
                    noResultContainer.classList.remove("hidden");
                  }
                  postContainer.innerHTML = "";
                } else {
                  if (!noResultContainer.classList.contains("hidden")) {
                    noResultContainer.classList.add("hidden");
                  }
                  postContainer.innerHTML = response.data.html;
                }
    
                if (response.data.load_more === "hide") {
                  if (!loadMoreMobile.classList.contains("hidden")) {
                    loadMoreContainerButton.classList.remove("lg:flex");
                    loadMoreMobile.classList.add("hidden");
                  }
                } else {
                  if (loadMoreMobile.classList.contains("hidden")) {
                    loadMoreContainerButton.classList.add("lg:flex");
                    loadMoreMobile.classList.remove("hidden");
                  }
                }
    
                mobileCountText.innerHTML =
                  "Meer reizen laden - " +
                  response.data.current_count +
                  " van de " +
                  response.data.total_count;
                counter.innerHTML = response.data.count;
    
                var headerOffset = 80;
                var elementPosition = archiveContainer.getBoundingClientRect().top;
                var offsetPosition =
                  elementPosition + window.scrollY - headerOffset;
    
                if (window.scrollY > 1200) {
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                  });
                }
    
                archiveContainer.removeAttribute("data-group-loading");
              }
            }
          })
          .catch((error) => {
            console.log(error);
            archiveContainer.removeAttribute("data-group-loading");
          });
    }

    loadMorePosts() {
        this.incrementPaged();
    
        // Get form data
        const formData = new FormData(this.formTarget);
        var archiveContainer = this.containerTarget;
        archiveContainer.setAttribute("data-group-loading", "true");
    
        // Get container
        var postContainer = this.postContainerTarget;
        var loadMoreContainerButton = this.loadMoreContainerTarget;
        var loadMoreMobile = this.loadMoreMobileTarget;
        var mobileCountText = this.mobileCountTarget;
    
        // Ajax request
        axios
          .post(supersage.ajaxURL, formData)
          .then((response) => {
            if (response.status == "200") {
              if (postContainer && response.data != "") {
                postContainer.innerHTML += response.data.html;
    
                archiveContainer.removeAttribute("data-group-loading");
    
                if (response.data.load_more === "hide") {
                    if (!loadMoreMobile.classList.contains("hidden")) {
                        loadMoreContainerButton.classList.remove("lg:flex");
                        loadMoreMobile.classList.add("hidden");
                    }
                  } else {
                    if (loadMoreMobile.classList.contains("hidden")) {
                        loadMoreContainerButton.classList.add("lg:flex");
                        loadMoreMobile.classList.remove("hidden");
                    }
                  }
    
                // Decrease 10 from current count because paged was already incremented
                mobileCountText.innerHTML =
                  "Meer reizen laden - " +
                  response.data.current_count +
                  " van de " +
                  response.data.total_count;
              }
            }
          })
          .catch((error) => {
            console.log(error);
            archiveContainer.removeAttribute("data-group-loading");
          });
    }

    resetPaged() {
        this.currentPageTarget.value = 1;
    }

    incrementPaged() {
        this.currentPageTarget.value = parseInt(this.currentPageTarget.value) + 1;
    }

    closeMobileMenu() {
        if(this.containerTarget.hasAttribute('data-group-active-sub')) {
            this.containerTarget.removeAttribute('data-group-active-sub');
            document.querySelector('body').classList.remove('overflow-hidden', 'max-h-screen');
        }
    }

    openMobileMenu() {
        if(!this.containerTarget.hasAttribute('data-group-active-sub')) {
            this.containerTarget.setAttribute('data-group-active-sub', true);
            document.querySelector('body').classList.add('overflow-hidden', 'max-h-screen');
        } 
    }
}
